import React from 'react';
import { View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';
import { REQUESTING, FAILED } from '../../actions/statusTypes';

import { connect } from 'react-redux';

import { RESIDENT_ADMINISTRATION } from '../../constants/permissions';
import { currentEmployerPermissions } from '../../helpers/permissions';

import { getCurrentEmployer } from '../../selectors/entities';
import { OPComponent, Container, I18n, PlusMenu, Utils, PlusButton } from '../components';

import CaseSearchPaginated from './case_search_paginated';

class AddMenu extends OPComponent {
  constructor(props) {
    super(props);
  }
  handleItemPress = (item) => {
    switch (item.id) {
      case 'resident':
        this.props.handleAddResident();
        break;
    }
  };
  handleAddPress = (item) => {
    this.props.handleAddResident();
  };
  render() {
    if (!this.props.canAddResident) return null;

    let items = [];
    return <PlusMenu noGradient={true} onAddPress={this.handleAddPress} />;
  }
}

class CaseSearchEmployer extends OPComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {}
  componentDidMount() {
    Utils.trackScreen('Residents', 'List');
  }
  componentDidUpdate(prevProps) {}

  render() {
    const props = this.props;
    if (!props.canView) return null;

    return (
      <Container
        style={THEME.container}
        renderActivityOverlay={props.status === REQUESTING}
        renderPlainOverlay={props.status === FAILED}
        confirmationOpts={props.confirmationOpts}
        errorMessage={props.errorMessage?.message}
      >
        <View style={{ flex: 1 }}>
          <CaseSearchPaginated
            autoLoadOnScroll={false}
            employerId={props.employerId}
            searchLabel={I18n.ce_aec('searchResidentsAF')}
            renderItem={props.renderItem}
            styleOverrides={{
              container: styles.container,
              searchHeader: styles.searchHeader,
              searchContainer: styles.searchContainer,
            }}
            renderHeader={props.renderHeader}
            toggleToRefreshSearch={props.toggleToRefreshSearch}
            includeConsults={props.includeConsults}
            headerRightComponent={
              !!props.canEdit && !!__WEB__ ? (
                <View style={{ justifyContent: 'center', marginLeft: 20 }}>
                  <PlusButton
                    buttonStyle={{ width: 40, height: 40 }}
                    onPress={props.handleAddResident}
                  />
                </View>
              ) : null
            }
          />
        </View>
        {!!props.canEdit && !__WEB__ && (
          <AddMenu canAddResident={true} handleAddResident={props.handleAddResident} />
        )}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        borderColor: COLOR.accent,
        borderWidth: 1,
        shadowColor: 'rgba(0, 0, 0, .1)',
        shadowOffset: { width: 0, height: 3 },
        shadowRadius: 9,
        minWidth: 800,
        margin: 20,
        marginBottom: 0,
        flex: 1,
      }
    : {
        ...THEME.container,
        borderColor: COLOR.accent,
        borderBottomWidth: 1,
      },
  searchHeader: __WEB__
    ? {
        backgroundColor: COLOR.altContrast,
        height: 60,
        flexDirection: 'row',
        paddingHorizontal: 10,
      }
    : null,
  searchContainer: __WEB__
    ? {
        width: 450,
      }
    : null,
  header: {
    height: 45,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.altContrast,
    borderColor: COLOR.altAccent,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
  listContainerStyle: {
    paddingBottom: 10,
  },
  iconStyle: {
    width: 40,
    height: 40,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    canView: currentEmployerPermissions(RESIDENT_ADMINISTRATION).canView,
    canEdit: currentEmployerPermissions(RESIDENT_ADMINISTRATION).canEdit,
    status: state.screens.cases.searchStatus,
    employerId: getCurrentEmployer(state)?.employerId,
  };
}

export default connect(mapStateToProps, null)(CaseSearchEmployer);
